import ScoreDetailsInfo from "../../models/ScoreDetailsInfo"

class ScoreDetailsInfoConverter {
    static convert({ scoreDetailsInfo }) {
        if (scoreDetailsInfo) {
            return new ScoreDetailsInfo({ subScoreDetails: scoreDetailsInfo.subScoreDetails, score: scoreDetailsInfo.score })
        } else {
            return new ScoreDetailsInfo({})
        }
    }
}

export default ScoreDetailsInfoConverter